<template lang="pug">
BriqExpansionPanel(
  :key="groupName"
  v-model="isExpanded"
  :keepPanelExpanded="keepPanelExpanded"
  )
  template(slot="header")
    .bold {{ groupName }}
  template(slot="content")
    .settings-section-wrapper
      div(v-for="(setting, index) in group" :key="setting.DisplayName")
        component(
          :is="getComponent(setting)"
          :setting="setting"
          required="required"
          :disabled="disabled"
          @change="newValue => updateSetting(setting, newValue)"
          )
</template>

<script>
import BriqExpansionPanel from '@v/components/BriqExpansionPanel.vue'
import SingleList from '@v/settings/application/advanced/field-types/SingleList.vue'
import Boolean from '@v/settings/application/advanced/field-types/Boolean.vue'
import MultiList from '@v/settings/application/advanced/field-types/MultiList.vue'
import MultiLineString from '@v/settings/application/advanced/field-types/MultiLineString.vue'
import StandardInput from '@v/settings/application/advanced/field-types/StandardInput.vue'
import StandardInputMultiple from '@v/settings/application/advanced/field-types/StandardInputMultiple.vue'
import Duration from '@v/settings/application/advanced/field-types/Duration.vue'
import Time from '@v/settings/application/advanced/field-types/Time.vue'

// todo: see if these components can be made functional to improve performance when all panels are expanded

export default {
  name: 'AdvancedSettingsPanel',
  components: {
    BriqExpansionPanel,
    SingleList,
    Boolean,
    MultiList,
    MultiLineString,
    StandardInput,
    StandardInputMultiple,
    Duration,
    Time,
  },
  props: {
    group: { type: Array, required: true },
    groupName: { type: String, required: true },
    expand: Boolean,
    disabled: Boolean,
    keepPanelExpanded: Boolean,
  },
  data() {
    return {
      isExpanded: this.expand || false,
    }
  },
  methods: {
    getComponent({ DataType, MaxOccurs }) {
      if (DataType === 'String' || DataType === 'Integer' || DataType === 'Decimal')
        return MaxOccurs !== 1 ? 'StandardInputMultiple' : 'StandardInput'
      return DataType
    },
    updateSetting(setting, newValue) {
      if (setting.DataType === 'MultiList') {
        setting.Values = (newValue && newValue.map(v => v.Value)) || []
      } else if (setting.MaxOccurs !== 1) {
        setting.Values = newValue || []
      } else {
        if (newValue === null) setting.Values = []
        else setting.Values[0] = newValue
      }
    },
  },
  watch: {
    expand(v) {
      this.isExpanded = v
    },
  },
}
</script>

<style scoped lang="stylus">
.settings-section-wrapper
  background white
  padding 16px 24px
</style>
